import { WidgetContentWrapper } from '@components/top-widget-panel/spi-panel/styled';
import styled from 'styled-components';

export const IOWidgetWrapper = styled(WidgetContentWrapper)`
  margin-left: 0;
  cursor: default;
  min-width: fit-content;
  display: flex;

  &:hover {
    background-color: #fff;
  }

  hr {
    position: relative;
    top: 8px;
  }
`;

export const IOCategoryWrapper = styled.div`
  padding: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const IOItemContentWrapper = styled.div<{
  isClickable?: boolean;
  highlight?: boolean;
}>`
  display: flex;
  flex-grow: 1;
  align-items: center;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  padding-left: 0;
  background-color: ${(props) => (props.highlight ? '#F2F8FF' : 'none')};
  border: ${(props) => (props.highlight ? '1px' : '0px')} solid #256eff;
  border-radius: 4px;
  gap: 5px;
  margin-right: 5px;
  min-width: 230px;
  &:hover {
    background-color: ${(props) => (props.isClickable ? '#F2F8FF' : 'none')};
  }
`;

export const IOItemValueWrapper = styled.div`
  font-size: 12px;
  width: 22%;
  font-weight: 500;
  text-align: right;
`;

export const IOItemTitleWrapper = styled.div`
  font-size: 12px;
  width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
`;
